module.exports = __webpack_public_path__ + "static/media/cimple-loader.51270071.gif";